import { render, staticRenderFns } from "./DictRadioGroup.vue?vue&type=template&id=5d45d7c2&scoped=true&"
import script from "./DictRadioGroup.vue?vue&type=script&lang=js&"
export * from "./DictRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./DictRadioGroup.vue?vue&type=style&index=0&id=5d45d7c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d45d7c2",
  null
  
)

export default component.exports